var map = {
	"./br/PT/S1/bg68.jpg": 11724,
	"./br/PT/bg68.jpg": 17762,
	"./in/EN/S1/bg68.jpg": 44528,
	"./ph/EN/S1/bg68.jpg": 22603,
	"./ph/EN/bg68.jpg": 66973,
	"./vn/VI/S1/bg68.jpg": 83865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35237;